import React, { useRef, useState } from 'react';
import { useAdminAuth } from '../AdminAuthContext';

const ImageUpload = ({ label, value, onChange }) => {
  const { token } = useAdminAuth();
  const fileRef = useRef();
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const API = process.env.REACT_APP_API_URL || 'http://localhost:4001';
  const previewSrc = value && !value.startsWith('http') ? `${API}${value}` : value;

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setError('');
    setUploading(true);
    try {
      const form = new FormData();
      form.append('image', file);
      const res = await fetch(`${API}/api/upload`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: form,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Erro no upload.');
      onChange(data.url);
    } catch (err) {
      setError(err.message);
    } finally {
      setUploading(false);
      fileRef.current.value = '';
    }
  };

  return (
    <div className="mb-5">
      {label && <label className="block text-sm font-semibold text-gray-700 mb-1">{label}</label>}

      <div className="flex gap-2 items-center">
        <input
          type="text"
          value={value || ''}
          onChange={e => onChange(e.target.value)}
          placeholder="https://... ou envie um arquivo"
          className="flex-1 border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button
          type="button"
          onClick={() => fileRef.current.click()}
          disabled={uploading}
          className="flex-shrink-0 flex items-center gap-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm font-medium px-4 py-2.5 rounded-xl transition-colors disabled:opacity-60"
        >
          <span className="material-icons text-base">{uploading ? 'hourglass_empty' : 'upload'}</span>
          {uploading ? 'Enviando...' : 'Upload'}
        </button>
        <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={handleFile} />
      </div>

      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}

      {value && (
        <div className="mt-2 relative inline-block">
          <img
            src={previewSrc}
            alt="Preview"
            className="max-h-32 rounded-xl border border-gray-200 object-cover"
            onError={e => e.target.style.display = 'none'}
          />
          <button
            onClick={() => onChange('')}
            className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center hover:bg-red-600 shadow"
            title="Remover imagem"
          >
            <span className="material-icons text-xs">close</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default ImageUpload;
